'use client';

import {
  ModButton,
  ModModal,
  ModModalContent,
  ModModalFooter
} from '@moderneinc/design-system-components';
import { semanticColors, typography } from '@moderneinc/design-system-tokens';
import { Typography } from '@mui/material';
import NextLink from 'next/link';
import type { FunctionComponent } from 'react';
import { MARKETPLACE_HOME_PATH } from '../../constants/general';
import { useTourEngineStore } from '../../stores/tour-engine.store';
import { TRIAL_TOUR_ID } from './trial-tour.config';

export const TrialCompletionModal: FunctionComponent = () => {
  const status = useTourEngineStore((state) => state.status);
  const activeTourId = useTourEngineStore((state) => state.activeTourId);
  const dismiss = useTourEngineStore((state) => state.dismiss);
  const open = status === 'completed' && activeTourId === TRIAL_TOUR_ID;

  return (
    <ModModal open={open} onClose={dismiss} maxWidth="sm" fullWidth>
      <ModModalContent>
        <Typography
          sx={{
            fontFamily: typography.fontFamily.heading,
            fontWeight: typography.fontWeight.bold,
            fontSize: typography.fontSize.h3,
            pt: 2
          }}
        >
          What&apos;s next
        </Typography>
        <Typography
          variant="body"
          sx={{ color: semanticColors.color.text.secondary, mt: 1 }}
        >
          There are thousands of other recipes in the marketplace, ready to try
          the same way.
        </Typography>
      </ModModalContent>
      <ModModalFooter
        leadingContent={
          <ModButton
            component={NextLink}
            variant="primary"
            size="medium"
            href={MARKETPLACE_HOME_PATH}
            onClick={dismiss}
          >
            Explore the marketplace
          </ModButton>
        }
      />
    </ModModal>
  );
};
